import { API_HOST } from "../constants/URL";

//La API utilizada es propiedad del usuario de GitHub anoldou: https://github.com/arnoldou/elsalvador-departamentos-municipios
export function getMunicipios() {
    const comUrl = `${API_HOST}/departamentos`;

    return fetch(comUrl)
        .then((response) => { return response.json(); })
        .then((result) => { return result; });
}